:host {
  display: block;
}

.featured-block-container {
  display: flex;
  flex-direction: column;
  gap: var(--margin-l);
  padding: var(--padding-xl);
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius);
  margin-bottom: var(--margin-l);
}

.featured-content {
  display: flex;
  flex-direction: column;
  gap: var(--margin-m);
}

.featured-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0;
}

.featured-description {
  font-size: var(--font-size-m);
  color: var(--color-text-secondary);
  line-height: 1.6;
  margin: 0;
}

.featured-image {
  width: 100%;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.featured-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  max-height: 300px;
}

@media (min-width: 768px) {
  .featured-block-container {
    flex-direction: row;
    align-items: center;
  }

  .featured-content {
    flex: 1;
  }

  .featured-image {
    flex: 0 0 40%;
    max-width: 400px;
  }

  .featured-image img {
    max-height: 250px;
  }
}
